import { AxiosResponse } from 'axios';
import { useAuth } from 'core/contexts';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { useQuery, UseQueryResult } from 'react-query';

export const useReceiptList = (
    props: any
): UseQueryResult<AxiosResponse<any[], any>, unknown> => {
    const { getToken } = useAuth();
    const headers = getDefaultHeaders(getToken());
    const { chain, contractType, queryProps, receiptType, enabled } = props;

    const queryKey =
        receiptType == 'admin'
            ? `${chain}-${contractType}-admin-receipts}`
            : `${chain}-${contractType}-user-self-receipts}`;
    const queryUrl =
        receiptType == 'admin'
            ? `graphchain/${chain}/${contractType}/receipts`
            : `graphchain/${chain}/${contractType}/receipts/self`;

    return useQuery(
        queryKey,
        async () => {
            return axiosInstance().get(queryUrl, withHeaders(headers));
        },
        { ...queryProps, enabled: enabled }
    );
};
